<template>
  <div class="Reportform">
    <el-form class="custom-formScreen" :model="formScreen" ref="formScreen" inline label-width="4.8vw">
      <el-form-item prop="branchCompanyId" label="选择分公司" v-if="[1].includes(UserInfo.type)">
        <el-select filterable v-model="formScreen.branchCompanyId" value-key="company_id"
          @change="selectChange($event, 'listSonCompany')">
          <el-option v-for="item in listBranchCompany" :key="item.company_id" :label="item.companyName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sonCompanyId" label="选择子公司" v-if="[2, 1].includes(UserInfo.type)">
        <el-select filterable v-model="formScreen.sonCompanyId" value-key="rid"
          @change="selectChange($event, 'listDepartment')">
          <el-option v-for="item in listSonCompany" :key="item.company_id" :label="item.companyName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择平台" prop="sellerType">
        <el-select v-model="formScreen.sellerType" placeholder="请选择" @change="shopChange8" clearable>
          <el-option v-for="item in platform" :key="item.sellerType" :label="item.itemTypeName"
            :value="item.sellerType"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="departmentVal" label="选择分部门"
        v-if="UserInfo.system < 3 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')">
        <el-select v-model="formScreen.departmentVal" value-key="rid" @change="selectChange($event, 'listGroup')">
          <el-option v-for="item in listDepartment" :key="item.rid" :label="item.departmentName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="groupVal" label="选择组"
        v-if="UserInfo.system < 4 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')">
        <el-select v-model="formScreen.groupVal" value-key="rid" @change="selectChange($event, 'listStaff')">
          <el-option v-for="item in listGroup" :key="item.rid" :label="item.groupName" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="staffVal" label="选择员工"
        v-if="UserInfo.system < 5 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')">
        <el-select v-model="formScreen.staffVal" value-key="rid" @change="selectChange($event, 'none')">
          <el-option v-for="item in listStaff" :key="item.rid" :label="item.roleUserName" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sid" label="选择店铺">
        <el-select v-model="formScreen.sid" :disabled="isShopDisabled">
          <el-option v-for="item in listShop" :key="item.id" :label="item.shop_name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="startTime" label="开始日期">
        <el-date-picker v-model="formScreen.startTime" type="datetime" placeholder="选择开始日期"
          value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item prop="endTime" label="结束日期">
        <el-date-picker v-model="formScreen.endTime" type="datetime" placeholder="选择结束日期"
          value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item prop="delivery" label="配送方式">
        <el-radio-group v-model="formScreen.delivery">
          <el-radio label="selfDelivery" @click.native.prevent="cancelSelect('selfDelivery', 'delivery')">自配送</el-radio>
          <el-radio label="platformDelivery"
            @click.native.prevent="cancelSelect('platformDelivery', 'delivery')">平台配送</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="searchVal" label=" " style="width: 40%">
        <el-input placeholder="请输入订单号/订单ID" v-model="formScreen.searchVal"
          style="width: calc(100% - 140px);"></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="searchForm"
          :loading="searchBtnLoading">搜索</el-button>
        <el-button type="primary" @click="resetForm" :loading="searchBtnLoading">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table border :data="listTableFirst" size="mini" v-loading="loadingTableFirst">
      <el-table-column prop="orderVolume" label="订单量" align="center"></el-table-column>
      <el-table-column prop="settlementQuantity" label="已划账订单量" align="center">
        <template slot-scope="{ row }">
          <span :class="{ 'highlight-text': Number(row.settlementQuantity) !== Number(row.orderVolume) }">
            {{ row.settlementQuantity }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="theTotalAmountOfOrders" label="订单总金额" align="center"></el-table-column>
      <el-table-column prop="actualTotalCost" label="实收总费用" align="center"></el-table-column>
      <el-table-column prop="freezeTotalCost" label="冻结总费用" align="center"></el-table-column>
      <el-table-column prop="totalCosts" label="成本" align="center"></el-table-column>
      <el-table-column prop="freezeTotalFees" label="冻结总成本" align="center"></el-table-column>
      <el-table-column prop="totalRefundFee" label="退款费用" align="center"></el-table-column>
      <el-table-column prop="totalAfterSalesFee" label="平台售后" align="center"></el-table-column>
      <el-table-column prop="totalProfit" label="利润" align="center"></el-table-column>
      <el-table-column prop="rateOrSelling" label="销售利润率" align="center"></el-table-column>
      <el-table-column prop="costProfitMargin" label="成本利润率" align="center"></el-table-column>
    </el-table>
    <el-divider></el-divider>
    <el-radio-group v-model="pageShow" size="small" @change="radioChange">
      <el-radio-button label="dateShow">按日期显示</el-radio-button>
      <el-radio-button label="orderShow">按订单显示</el-radio-button>
    </el-radio-group>

    <div class="leftSet">
      <el-popover placement="left" trigger="click" style="float: right; margin-left: 20px;"
        v-show="pageShow == 'dateShow'">
        <div>
          <el-date-picker v-model="daochudata" type="datetimerange" size="small" value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
          <el-button type="primary" @click="daochusubmit" style="float: right; margin-left: 10px;">
            确定
          </el-button>
        </div>
        <el-button type="primary" slot="reference" @click="dialogSetVisible1 = true"
          v-if="UserInfo.type == 3 && (UserInfo.system == 1 || UserInfo.superDepartmentName == '财务部')">
          导出
        </el-button>
      </el-popover>
    </div>

    <!-- 按日期显示 -->
    <template v-if="pageShow === 'dateShow'">
      <el-table key="third" :data="listTableThird" border size="mini" v-loading="loadingTableThird">
        <el-table-column prop="time" label="日期" align="center"></el-table-column>
        <el-table-column prop="quantityOfOrder" label="订单量" align="center"></el-table-column>
        <el-table-column prop="settlementQuantity" label="已划账订单量" align="center">
          <template slot-scope="{ row }">
            <span :class="{ 'highlight-text': Number(row.settlementQuantity) !== Number(row.quantityOfOrder) }">
              {{ row.settlementQuantity }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmountOfOrder" label="销售额" align="center"></el-table-column>
        <el-table-column prop="actualTotalCost" label="实际总费用" align="center"></el-table-column>
        <el-table-column prop="totalRefundFee" label="退费总费用" align="center"></el-table-column>
        <el-table-column prop="adSpendAmount" label="广告费用" align="center"></el-table-column>
        <el-table-column prop="totalLogisticsCost" label="物流费用" align="center"></el-table-column>
        <el-table-column prop="totalPurchaseCost" label="采购费用" align="center"></el-table-column>
        <el-table-column prop="totalPlatformCost" label="平台费用" align="center"></el-table-column>
        <el-table-column prop="totalAfterSalesFee" label="平台售后" align="center"></el-table-column>
        <el-table-column align="center">
          <template slot="header">
            其它成本
            <el-popover trigger="hover" placement="top">
              <p>收件费用、退件费用、分装费用、合装费用、包材费用、仓储费用、提现费用</p>
              <i class="iconfont icon-tishi" slot="reference"></i>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.totalWarehouseCost }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalProfit" label="利润" align="center"></el-table-column>
      </el-table>
      <el-row type="flex" justify="center" align="middle" class="pagination-box">
        <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="page1"
          :page-sizes="[10, 20, 50, 100]" :page-size="size1" layout="total, sizes, prev, pager, next, jumper"
          :total="total1"></el-pagination>
      </el-row>
      <div class="echart" id="dateLine"
        style="width: 80%; height: 400px;  margin-left: auto; margin-right: auto; margin-top: 25px;"></div>
    </template>
    <!-- 按订单显示 -->
    <template v-else-if="pageShow === 'orderShow'">
      <el-table key="second" :data="listTableSecond" size="mini" v-loading="loadingTableSecond">
        <el-table-column prop="purchaseDate" label="日期" width="88" align="center"></el-table-column>
        <el-table-column prop="orderId" label="订单ID" width="120" align="center"></el-table-column>
        <el-table-column label="收入" align="center">
          <el-table-column prop="amountChina" label="订单总价（不含税）" align="center">
          </el-table-column>
          <el-table-column prop="taxChina" label="税" align="center"></el-table-column>
          <el-table-column prop="feeAmountChina" label="佣金" align="center"></el-table-column>
          <el-table-column prop="csbafeeChina" label="亚马逊客服费" align="center"></el-table-column>
          <el-table-column prop="refundChina" label="退款费用" align="center"></el-table-column>
          <el-table-column prop="refundCommissionChina" label="退款管理费" align="center"></el-table-column>
          <el-table-column prop="orderActualCharge" label="实收费用" align="center"></el-table-column>
        </el-table-column>
        <el-table-column label="成本" align="center">
          <el-table-column prop="logisticsCost" label="物流费用" align="center"></el-table-column>
          <el-table-column prop="purchaseCost" label="采购费用" align="center"></el-table-column>
          <el-table-column prop="warehouseCost" label="仓库杂费" align="center"></el-table-column>
          <el-table-column prop="platformCost" label="平台费用" align="center"></el-table-column>
          <el-table-column prop="afterSalesFee" label="平台售后" align="center"></el-table-column>
          <el-table-column prop="withdrawalCost" label="提现费用" align="center">
            <template slot="header">
              <el-tooltip effect="dark" placement="top">
                <template slot="content">
                  <span style="cursor: pointer;" @click="openWithdrawalRatio">{{ (withdrawalRatio || 0.00) + '%'
                  }}</span>
                </template>
                <span>提现费用</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orderTotalCost" label="成本总计" align="center"></el-table-column>
        </el-table-column>
        <el-table-column label="利润" align="center">
          <el-table-column prop="orderProfit" label="利润" align="center"></el-table-column>
          <el-table-column prop="costProfitMargin" label="成本利润率" align="center"></el-table-column>
          <el-table-column prop="rateOrSelling" label="销售利润率" align="center"></el-table-column>
        </el-table-column>
        <el-table-column prop="amazonOrderId" label="订单号" align="center" width="160"></el-table-column>
      </el-table>
      <el-row type="flex" justify="center" align="middle" class="pagination-box">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
          :page-sizes="[10, 20, 50, 100, 2000]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </el-row>
    </template>

    <el-dialog title="修改提现费用比例" width="30%" :visible.sync="dialogVisible">
      <el-form label-width="80px">
        <el-form-item label="提现比例">
          <el-input v-model="withdrawalRatio2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateWithdrawalRatio" :loading="loadingStatus === 'dialogVisible'">确
          定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ajaxPost, Baseurl } from '@/api/api/api';
import * as echarts from 'echarts';
export default {
  name: "storPerformance",
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick: (picker) => {
            const date = new Date()
            picker.$emit('pick', date);
            this.calculationDate()
          }
        }, {
          text: '上一月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-1)
          }
        }, {
          text: '上两月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-2)
          }
        }, {
          text: '上三月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-3)
          }
        }]
      },
      UserInfo: {},
      companyId: '',
      rid: '',
      system: '',
      formScreen: {
        branchCompanyId: '',
        sonCompanyId: '',
        departmentVal: '',
        groupVal: '',
        staffVal: '',
        sid: '',
        startTime: '',
        endTime: '',
        searchVal: '',
        sellerType: '',
        delivery: '',
      },
      page: 1,
      size: 10,
      total: 0,
      listTableFirst: [],
      listTableSecond: [],

      listBranchCompany: [],
      listSonCompany: [],
      listDepartment: [],
      listGroup: [],
      listStaff: [],
      listShop: [],

      loadingTableFirst: false,
      loadingTableSecond: false,
      dialogVisible: false,
      withdrawalRatio: '',
      withdrawalRatio2: '',
      loadingStatus: '',
      pageShow: 'dateShow',
      listTableThird: [],
      loadingTableThird: false,
      page1: 1,
      size1: 10,
      total1: 0,
      platform: [],
      searchBtnLoading: false,
      dialogSetVisible: false,
      dialogSetVisible1: false,
      daochudata: [],
    };
  },
  computed: {
    isShopDisabled() {
      if (this.UserInfo.system === 5 && this.UserInfo.superDepartmentName === '运营部') {
        return false
      } else {
        return !this.formScreen.staffVal
      }
    },
    screenObj() {
      return {
        companyId: this.companyId,
        rid: this.rid,
        system: this.system,
        sid: this.formScreen.sid,
      }
    }
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem('role'))
    this.companyId = this.UserInfo.company_id
    this.rid = this.UserInfo.rid
    this.system = this.UserInfo.system

    this.init()
    this.getThisMonth()
    if (this.UserInfo.type === 3 && this.UserInfo.system === 5) {
      this.getListShop()
    }
    this.getTableFirst()
    this.radioChange(this.pageShow)
    if (this.UserInfo.type === 3) {
      this.getPlatform();
    }
  },
  methods: {
    cancelSelect(value, field) {
      if (value === this.formScreen[field]) {
        this.formScreen[field] = '';
      } else {
        this.formScreen[field] = value;
      }
    },
    init() {
      const { rid, system, company_id: companyId, type } = this.UserInfo;
      let listType = "";
      this.withdrawalRatio = this.UserInfo.company.withdrawalRatio
      if (type === 1) {
        listType = "listBranchCompany";
      } else if (type === 2) {
        listType = "listSonCompany";
      } else {
        listType = "listDepartment";
      }
      if (type === 3) {
        if (system === 3) {
          listType = "listGroup";
        } else if (system === 4) {
          listType = "listStaff";
        }
      }
      this.getNextPower(rid, system, companyId, listType);
    },
    daochusubmit() {
      if (!this.daochudata || !this.daochudata.length) {
        this.$message.error('请先选择时间范围！')
        return
      }
      window.open(`${Baseurl}performanceController/platformSellerPerformanceExport?start=${this.daochudata[0]}&end=${this.daochudata[1]}&companyId=${this.companyId}&rid=${this.UserInfo.rid}`, 'target');
    },
    shopChange8() {
      if (this.UserInfo.type !== 3) {
        this.rid = this.formScreen.sonCompanyId.rid;
        this.system = this.UserInfo.system;
      } else {
        this.rid = this.UserInfo.rid;
        this.system = this.UserInfo.system;
      }
      this.getNextPower(this.rid, this.system, this.companyId, 'listDepartment');
      this.formScreen.departmentVal = '';
      this.formScreen.groupVal = '';
      this.formScreen.staffVal = '';
      this.listStaff = [];
      this.formScreen.sid = '';
      this.listShop = []
      this.listGroup = [];
    },
    getPlatform() {
      const API = Baseurl + 'sellerController/selectSellerTypeByRid'
      const paramsData = {
        rid: this.rid
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.platform = res.data.data
        } else {
          this.platform = []
          this.$message.error(res.data.data)
        }
      })
    },
    getNextPower(rid, system, companyId, type) {
      const API = Baseurl + "roleController/selectNextAndSellerInfoByRid";
      let paramsData = { rid, system, companyId, sellerType: this.formScreen.sellerType };

      ajaxPost(API, paramsData).then(res => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          this[type] = data.next;
        }
      });
    },
    selectChange(event, type) {
      const { rid, system, company_id: companyId } = event;
      companyId && (this.companyId = companyId);
      rid && (this.rid = rid);
      system && (this.system = system);
      if (!system) this.system = this.UserInfo.system;
      if (!companyId) this.companyId = this.UserInfo.company_id;
      if (!rid) this.rid = this.UserInfo.rid;

      this.listShop = []
      this.formScreen.sid = ''
      if (type === "none") {
        this.getListShop()
        return;
      }
      this.getNextPower(rid, system, companyId, type);

      if (type == "listDepartment") {
        this.getPlatform();
      }

      this.formScreen.staffVal = {};
      this.listStaff = [];
      if (type === "listStaff") return;
      this.formScreen.groupVal = {};
      this.listGroup = [];
      if (type === "listGroup") return;
      this.formScreen.departmentVal = {};
      this.listDepartment = [];
      this.formScreen.sellerType = '';
      this.platform = [];
      if (type === "listDepartment") return;
      this.formScreen.sonCompanyId = {};
      this.listSonCompany = [];
    },
    getThisMonth() {
      const nowDate = new Date()
      const nowTimeStamp = nowDate.getTime()
      const nowYear = nowDate.getFullYear()
      const nowMonth = nowDate.getMonth() + 1
      const nowDay = nowDate.getDate()

      const startTimeStamp = nowTimeStamp - (3600 * 1000 * 24 * 30)
      const startDate = new Date(startTimeStamp)
      const startYear = startDate.getFullYear()
      const startMonth = startDate.getMonth() + 1
      const startDay = startDate.getDate()

      this.formScreen.startTime = `${startYear}-${startMonth}-${startDay} 00:00:00`
      this.formScreen.endTime = `${nowYear}-${nowMonth}-${nowDay} 23:59:59`
    },
    radioChange(event) {
      if (event === 'orderShow') {
        this.getTableScond()
      } else if (event === 'dateShow') {
        this.getTableThird()
      }
    },
    getTableFirst() {
      const API = Baseurl + 'orderPerformanceController/getOrderTotalPerformanceByRoleIdNew'
      const paramsData = {
        startTime: this.formScreen.startTime || '',
        endTime: this.formScreen.endTime || '',
        searchVal: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        delivery: this.formScreen.delivery,
        ...this.screenObj
      }
      this.loadingTableFirst = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTableFirst = false
        if (code === 200) {
          this.listTableFirst = [data]
        } else {
          this.$message.error(data)
        }
      })
    },
    getTableScond() {
      const API = Baseurl + 'orderPerformanceController/getOrderPerformanceByRoleIdNew'
      const paramsData = {
        page: this.page,
        size: this.size,
        startTime: this.formScreen.startTime || '',
        endTime: this.formScreen.endTime || '',
        searchVal: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        delivery: this.formScreen.delivery,
        ...this.screenObj
      }
      this.loadingTableSecond = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTableSecond = false
        this.searchBtnLoading = false
        if (code === 200) {
          // data.list.forEach(item => item.amountChina = item.money.amountChina)
          data.list.forEach(item => {
            const amountChina = +((item.amountChina || 0) - (item.taxChina || 0)).toFixed(2);
            let rateOrSelling = '';
            if(+amountChina){
              rateOrSelling = ((item.orderProfit || 0) / +amountChina).toFixed(5);
            }
            item.amountChina = amountChina;
            item.rateOrSelling = rateOrSelling;
          })
          this.listTableSecond = data.list
          this.total = data.total
        }
      })
    },
    getTableThird() {
      const API = Baseurl + 'orderPerformanceController/selectStorePerformanceStatisticsNew'
      const paramsData = {
        page: this.page1,
        size: this.size1,
        startTime: this.formScreen.startTime || '',
        endTime: this.formScreen.endTime || '',
        searchVal: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        delivery: this.formScreen.delivery,
        ...this.screenObj
      }
      this.loadingTableThird = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTableThird = false
        this.searchBtnLoading = false
        if (code === 200) {
          // data.list.forEach(item => item.amountChina = item.money.amountChina)
          this.listTableThird = data.list
          this.total1 = data.total

          let timeData = []
          let quantityOfOrderData = []
          let totalAmountOfOrderData = []
          let actualTotalCostData = []
          let totalRefundFeeData = []
          let adSpendAmountData = []
          let totalLogisticsCostData = []
          let totalPurchaseCostData = []
          let totalPlatformCostData = []
          let totalAfterSalesFeeData = []
          let totalWarehouseCostData = []
          let totalProfitData = []

          const dateLine = echarts.init(document.getElementById('dateLine'))

          timeData = this.listTableThird.map(item => item.time)
          quantityOfOrderData = this.listTableThird.map(item => item.quantityOfOrder)
          totalAmountOfOrderData = this.listTableThird.map(item => item.totalAmountOfOrder)

          actualTotalCostData = this.listTableThird.map(item => item.actualTotalCost)
          totalRefundFeeData = this.listTableThird.map(item => item.totalRefundFee)
          adSpendAmountData = this.listTableThird.map(item => item.adSpendAmount)
          totalLogisticsCostData = this.listTableThird.map(item => item.totalLogisticsCost)
          totalPurchaseCostData = this.listTableThird.map(item => item.totalPurchaseCost)
          totalPlatformCostData = this.listTableThird.map(item => item.totalPlatformCost)
          totalAfterSalesFeeData = this.listTableThird.map(item => item.totalAfterSalesFee)
          totalWarehouseCostData = this.listTableThird.map(item => item.totalWarehouseCost)
          totalProfitData = this.listTableThird.map(item => item.totalProfit)


          dateLine.setOption({
            tooltip: {
              trigger: 'axis',
              position: function (pt) {
                return [pt[0], '10%'];
              }
            },
            legend: {
              left: 'center',
              width: '80%',
              textStyle: {
                color: '#4c9bfd' // 图例文字颜色
              }
            },
            grid: {
              top: "20%",
              left: "3%",
              right: "4%",
              bottom: "3%",
              show: true, // 显示边框
              borderColor: "#012f4a", // 边框颜色
              containLabel: true // 包含刻度文字在内
            },
            title: {
              text: '日期统计数据'
            },
            toolbox: {
              feature: {
                dataZoom: {
                  yAxisIndex: 'none'
                },
                restore: {},
                saveAsImage: {}
              }
            },
            xAxis: {
              boundaryGap: false,
              data: timeData,
              // data: [1,2,3,4,5,6,7,8,9,10],
              inverse: true
            },
            yAxis: {
              type: 'value',
              boundaryGap: [0, '40%'],
              axisLine: {
                show: false // 去除轴线
              },
              splitLine: {
                lineStyle: {
                  color: "#012f4a" // 分割线颜色
                }
              }
            },
            series: [
              {
                name: '订单量',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: quantityOfOrderData
              },
              {
                name: '销售额',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: totalAmountOfOrderData
              },
              {
                name: '实际总费用',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: actualTotalCostData
              },
              {
                name: '退费总费用',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: totalRefundFeeData
              },
              {
                name: '广告费用',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: adSpendAmountData
              },
              {
                name: '物流费用',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: totalLogisticsCostData
              },
              {
                name: '采购费用',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: totalPurchaseCostData
              },
              {
                name: '平台费用',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: totalPlatformCostData
              },
              {
                name: '平台售后',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: totalAfterSalesFeeData
              },
              {
                name: '其它成本',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: totalWarehouseCostData
              },
              {
                name: '利润',
                type: 'line',
                smooth: true,
                // 设置拐点
                symbol: "circle",
                // 拐点大小
                symbolSize: 5,
                // 开始不显示拐点， 鼠标经过显示
                showSymbol: false,
                data: totalProfitData
              }
            ]
          })
          window.addEventListener("resize", function () {
            dateLine.resize();
          });
        }
      })
    },
    getListShop() {
      const API = Baseurl + 'sellerController/selectMyShopByRid1'
      const paramsData = {
        rid: this.rid,
        system: this.system
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listShop = data
        }
      })
    },
    searchForm() {
      this.getTableFirst()
      this.searchBtnLoading = true
      if (this.pageShow === 'orderShow') {
        this.page = 1
        this.getTableScond()
      } else if (this.pageShow === 'dateShow') {
        this.page1 = 1
        this.getTableThird()
      }
    },
    resetForm() {
      this.page = 1
      this.$refs.formScreen.resetFields();
      this.listBranchCompany = [];
      this.listSonCompany = [];
      this.listDepartment = [];
      this.listGroup = [];
      this.listStaff = [];
      this.listShop = [];
      this.rid = this.UserInfo.rid
      this.system = this.UserInfo.system
      this.companyId = this.UserInfo.company_id

      this.init();
      this.getThisMonth()
      this.searchForm()
    },
    handleSizeChange(val) {
      this.size = val
      this.getTableScond()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getTableScond()
    },
    handleSizeChange1(val) {
      this.size1 = val
      this.getTableThird()
    },
    handleCurrentChange1(val) {
      this.page1 = val
      this.getTableThird()
    },
    calculationDate(type = 0) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12);
      const newMonth = (month + type - 1 + 12) % 12 + 1;
      this.formScreen.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;

      const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
      this.formScreen.endTime = `${prevMonth} 23:59:59`
    },
    openWithdrawalRatio() {
      const { type, system, superDepartmentName } = this.UserInfo
      if ((type === 3 && system === 1) || (type === 3 && superDepartmentName === '财务部')) {
        this.withdrawalRatio2 = this.withdrawalRatio
        this.dialogVisible = true
      }
    },
    updateWithdrawalRatio() {
      const API = Baseurl + 'companyController/updateCompanyWithdrawalRatio'
      const paramsData = {
        id: this.UserInfo.company_id,
        withdrawalRatio: this.withdrawalRatio2
      }
      this.loadingStatus = 'dialogVisible'
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingStatus = ''
        if (code === 200) {
          this.UserInfo.company = data
          localStorage.setItem('role', JSON.stringify(this.UserInfo))
          this.withdrawalRatio = this.UserInfo.company.withdrawalRatio
          this.$message.success('操作成功')
          this.searchForm()
          this.dialogVisible = false
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.Reportform {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}

.highlight-text {
  color: red;
  /* 显眼的颜色 */
  font-weight: bold;
  /* 可选：加粗 */
}
</style>
